<template>
    <div>
        <div class="dataTitle">
            <div class="title">{{title}}</div>
            <div style="display: flex;justify-content: center;align-items: center;">
                <InputField label="" type="text" label-width="0%" id="outerRiverName" style="margin-right: 1rem;"
                             :modelValue="preForm.outerRiverName" placeholder="请输入外河名称"
                             @update:modelValue="(value) => handleModelPreValueUpdate('outerRiverName', value)"/>
                <a-space>
                    <ButtonField style="width: 80px;" text="查询" secondary @click="getlistWatLvlCtrlPage"/>
                    <ButtonField text="新增" @click="add" secondary />
                </a-space>
            </div>
        </div>
        <Tablelist
            :showCheckbox="false"
            :list="list"
            :columns="tableColumns"
            :totalSize="preForm.totalSize"
            :totalPages="preForm.totalPages"
            :pageNum="preForm.pageNum"
            :pageSize="preForm.pageSize"
            @page-change="onChange"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a href="#" @click.prevent="editText(item)">编辑</a>
                    <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>

        <Modal v-if="visible" v-model="visible"
               :visible="visible"
               :title="editShow?'编辑水位控制':'新增水位控制'"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'50%'"
               @update:visible="visible = $event">
            <form>
                <div class="formDiv">
                    <div>
                        <InputField label="外河名称" type="text"  id="outerRiverName" labelWidth="80%"
                                    :modelValue="form.outerRiverName" placeholder="请输入区域名称"
                                    @update:modelValue="(value) => handleModelValueUpdate('outerRiverName', value)"/>
                    </div>
                    <div>
                        <InputField label="外河设计洪水位(米)" type="text"  id="designFloodLevel" labelWidth="80%"
                                    :modelValue="form.designFloodLevel" placeholder="请输入外河设计洪水位(米)"
                                    @update:modelValue="(value) => handleModelValueUpdate('designFloodLevel', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="外河常水位(米)" type="Number"  id="normalWaterLevel" labelWidth="80%"
                                    :modelValue="form.normalWaterLevel" placeholder="请输入外河常水位(米)"
                                    @update:modelValue="(value) => handleModelValueUpdate('normalWaterLevel', value)"/>
                    </div>
                    <div>
                        <InputField label="外河最低水位(米)" type="Number"  id="lowestWaterLevel" labelWidth="80%"
                                    :modelValue="form.lowestWaterLevel" placeholder="请输入外河最低水位(米)"
                                    @update:modelValue="(value) => handleModelValueUpdate('lowestWaterLevel', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="内河控制水位上限(米)" type="Number"  id="upperControlLevel" labelWidth="80%"
                                    :modelValue="form.upperControlLevel" placeholder="请输入内河控制水位上限(米)"
                                    @update:modelValue="(value) => handleModelValueUpdate('upperControlLevel', value)"/>
                    </div>
                    <div>
                        <InputField label="内河控制水位下限(米)" type="Number"  id="lowerControlLevel" labelWidth="80%"
                                    :modelValue="form.lowerControlLevel" placeholder="请输入内河控制水位下限(米)"
                                    @update:modelValue="(value) => handleModelValueUpdate('lowerControlLevel', value)"/>
                    </div>
                </div>

                <div style="display: flex;justify-content: center;">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" v-if="!saveShow" primary @click="handleSubmit"/>
                        <ButtonField text="下一步" v-else primary @click="handleNextStep"/>
                    </a-space>
                </div>
            </form>
        </Modal>
    </div>
</template>

<script>
import {fetchWatLvlCtrlPageList, saveWatLvlCtrl, modifyWatLvlCtrl,remove} from "@/views/diagnose/api/diagnose";

export default {
    name: "index",
    data() {
        return {
            preForm:{
                totalSize: 1,
                totalPages: 1,
                pageNum: 1,
                pageSize: 10,
            },
            form:{
                outerRiverName:null,designFloodLevel:null,normalWaterLevel:null,lowestWaterLevel:null,upperControlLevel:null,lowerControlLevel:null
            },
            visible:false,
            editShow:false,
            saveShow:false,
            list:[],
            tableColumns:[
                {key: 'outerRiverName',title: '外河名称',field: 'outerRiverName',width: '100px'},
                {key: 'designFloodLevel',title: '外河设计洪水位（米）',field: 'designFloodLevel',width: '100px'},
                {key: 'normalWaterLevel',title: '外河常水位（米）',field: 'normalWaterLevel',width: '100px'},
                {key: 'lowestWaterLevel',title: '外河最低水位（米）',field: 'lowestWaterLevel',width: '100px'},
                {key: 'upperControlLevel',title: '内河控制水位上限（米）',field: 'upperControlLevel',width: '120px'},
                {key: 'lowerControlLevel',title: '内河控制水位下限（米）',field: 'lowerControlLevel',width: '120px'},
                {key: 'actions',title: '操作',field: 'actions', infotype: 'template',width: '150px'},
            ]
        }
    },
    props:{
        title: {
            type: String,
            default: null,
        },
    },
    mounted() {
        this.getlistWatLvlCtrlPage();
    },
    methods: {
        formatDate(dateString){
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        },
        onChange(pagination) {
            this.preForm.pageNum  = pagination;
            this.preForm.pageSize = 10;
            this.getlistWatLvlCtrlPage();
        },
        getlistWatLvlCtrlPage(){
            fetchWatLvlCtrlPageList(this.preForm).then(res => {
                this.list = res.list.map(item => ({
                    ...item,
                    daytime: this.formatDate(item.daytime)
                }));
                this.preForm.totalPages = res.totalPages;
                this.preForm.totalSize = res.totalSize;
            })
        },
        handleModelPreValueUpdate(fieldName, value){
            this.preForm[fieldName] = value;
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        add(){
            this.visible = true;
            this.editShow = false;
            this.saveShow = false;
            this.form = {}
        },
        editText(item){
            console.log("item:::",item)
            this.visible = true;
            this.editShow = true;
            this.saveShow = false;
            this.form = item;
        },
        deleteText(item){
            console.log("item:::",item)
            remove({
                id: item.id,
                type: "diagnose_watlvl_ctrl"
            }).then((res) => {
                console.log("res:", res);
                this.getlistWatLvlCtrlPage();
            }).catch((error) => {
                console.error("删除失败:", error);
            });
        },
        cancel() {
            this.visible = false;
        },
        handleSubmit(){
            this.form.daytime = new Date();
            if(this.form.id){
                modifyWatLvlCtrl(this.form).then(res => {
                    console.log("modifySewagePage   res:::",res)
                    this.getlistWatLvlCtrlPage()
                })
            }else{
                saveWatLvlCtrl(this.form).then(res => {
                    console.log("saveSewagePage   res:::",res)
                    this.getlistWatLvlCtrlPage()
                })
            }
            this.saveShow = true
        },
        handleNextStep(){
            this.visible = false;
            this.$bus.$emit('switch-component', 'watStaPla');
        }
    }
}
</script>
<style scoped>
.dataTitle{
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin:0 0 1rem 0;
}
.title{
    font-size: 1.2rem;
    color: #00ff96;
    font-weight: bold;
}
.formDiv{
    display: flex;
    justify-content: space-between;
    margin: 1rem 0;
}
.formDiv > div{
    width: 48%;
}
</style>